import supabase from "../../../supabase";

/**
 * Verifica el estado actual del sistema desde la base de datos
 * @returns {Promise<boolean>} - true si el sistema está activo, false si está inactivo
 * @throws {Error} - Si hay un error al consultar o crear el registro de estado
 */
export const checkSystemStatus = async () => {
  try {
    // Consultar el estado actual del sistema
    const { data, error } = await supabase
      .from("status")
      .select("status")
      .limit(1);

    if (error) {
      throw new Error(`Error obteniendo estado del sistema: ${error.message}`);
    }
    // Si no existe registro, crear uno por defecto
    if (!data || data.length === 0) {
      const { error: insertError } = await supabase
        .from("status")
        .insert([{ id: 1, status: true }]);
      if (insertError) {
        throw new Error(
          `Error creando registro en status: ${insertError.message}`
        );
      }
      return true;
    }
    // Retornar el estado actual del sistema
    const systemStatus = data[0].status;
    return systemStatus;
  } catch (error) {
    throw new Error(`Error verificando estado del sistema: ${error.message}`);
  }
};

/**
 * Actualiza el estado del sistema en la base de datos
 * @param {boolean} status - El nuevo estado del sistema (true = activo, false = inactivo)
 * @throws {Error} - Si hay un error al actualizar el estado
 */
export const updateSystemStatus = async (status) => {
  try {
    // Verificar si existe un registro de estado
    const { data: existingData, error: checkError } = await supabase
      .from("status")
      .select("id")
      .limit(1);
    if (checkError) {
      throw new Error(
        `Error verificando existencia del registro: ${checkError.message}`
      );
    }
    // Si no existe registro, crear uno nuevo
    if (!existingData || existingData.length === 0) {
      const { error: insertError } = await supabase
        .from("status")
        .insert([{ 
          id: 1, 
          status,
          created_at: new Date()
        }]);

      if (insertError) {
        throw new Error(
          `Error creando registro en status: ${insertError.message}`
        );
      }
    } else {
      // Actualizar el registro existente
      const { error: updateError } = await supabase
        .from("status")
        .update({ 
          status,
          created_at: new Date()
        })
        .eq("id", 1);

      if (updateError) {
        throw new Error(
          `Error actualizando estado del sistema: ${updateError.message}`
        );
      }
    }
  } catch (error) {
    throw new Error(`Error actualizando estado del sistema: ${error.message}`);
  }
};
